import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter
} from '@/components/ui/dialog';

export const ConfirmRotateDialog = ({ open, onOpenChange, onConfirm }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-slate-50 border-slate-200 text-slate-900" data-testid="confirm-rotate-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <AlertTriangle className="w-5 h-5 text-indigo-700" /> Rodar chave de API?
        </DialogTitle>
        <DialogDescription className="text-slate-500">
          A chave atual deixará de funcionar imediatamente. Terá de atualizar o CogniHub com a nova chave, caso contrário o provisionamento deixará de funcionar.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}
          className="border-slate-300 text-slate-700" data-testid="cancel-rotate-btn">
          Cancelar
        </Button>
        <Button onClick={onConfirm} className="bg-indigo-700 hover:bg-amber-600 text-black" data-testid="confirm-rotate-btn">
          Sim, gerar nova chave
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
